import { CheckBox } from "./check-box";

export class SwitchBox extends CheckBox {
    //
}
